var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1500 1500",
    style: {
      enableBackground: "new 0 0 1500 1500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\t.st0{fill:#FFFFFF;stroke:#39526E;stroke-width:37.5;stroke-linecap:round;stroke-miterlimit:10;}\t.st1{fill:none;stroke:#EEA220;stroke-width:50;stroke-linecap:square;stroke-miterlimit:10;}\t.st2{fill:#3A526E;stroke:#3A526E;stroke-width:150;stroke-linecap:square;stroke-miterlimit:10;}\t.st3{fill:#3A526E;stroke:#3A526E;stroke-width:18.75;stroke-linecap:square;stroke-miterlimit:10;}\t.st4{fill:#3A526E;stroke:#3A526E;stroke-width:25;stroke-linecap:round;stroke-miterlimit:10;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1197,1447.7H302.7c-139.4,0-253.5-114.1-253.5-253.5V299.8c0-139.4,114.1-253.5,253.5-253.5H1197  c139.4,0,253.5,114.1,253.5,253.5v894.4C1450.6,1333.6,1336.5,1447.7,1197,1447.7z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 275.2,
    y1: 1158.4,
    x2: 1216.8,
    y2: 1158.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 749.8,
    y1: 732.2,
    x2: 748.5,
    y2: 864.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.7,
    y: 519.7,
    className: "st3",
    width: 131.4,
    height: 60.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.7,
    y: 400.6,
    className: "st3",
    width: 131.4,
    height: 35.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.7,
    y: 282.3,
    className: "st3",
    width: 131.4,
    height: 35.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "747.1,1063 637.1,872.3 857.2,872.3  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPress);
export default __webpack_public_path__ + "static/media/press.5c6e4d17b1e744688ffb61528a2a032a.svg";
export { ForwardRef as ReactComponent };